/* eslint-disable eqeqeq,no-param-reassign,@typescript-eslint/no-shadow,no-underscore-dangle,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { EVENTS } from '../../../../app/constants/events';
import { updateVariables } from '../../../../app/package-designer/store/variables.actions';
import { setDidUserSaveVariablesFlag } from '../../../../app/package-designer/store/flags.actions';

xplenty.directive('packageVariablesEditor', [
  '$timeout',
  '$rootScope',
  'variables',
  'ngrxStoreService',
  'dynamicConnectionService',

  function ($timeout, $rootScope, variablesService, ngrxStoreService, dynamicConnectionService) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./package-variables-editor.html'),

      replace: true,

      scope: {
        variables: '=ngModel',
        variablesToSet: '=',
        valid: '=?',
        error: '=?',
        disabled: '=?',
      },

      link(scope, element, attrs) {
        scope.isInModalPanel = element.closest('.modal-panel-body').length > 0;

        if (attrs.usePackageDefault) {
          scope.usePackageDefault = attrs.usePackageDefault === 'true';
        }

        if (attrs.editable) {
          scope.editable = !(attrs.editable === 'false');
        }

        if (attrs.hideAdd) {
          scope.hideAdd = attrs.hideAdd === 'true';
        }

        if (attrs.hideFooter) {
          scope.hideFooter = attrs.hideFooter === 'true';
        }

        if (attrs.showUndo) {
          scope.showUndo = attrs.showUndo === 'true';
        }

        if (attrs.disableKey) {
          scope.disableKey = attrs.disableKey === 'true';
        }

        const separateVariables = function (usePackageDefault) {
          variablesService.separateVariables(scope.variables, scope.variablesToSet, usePackageDefault, function (vars) {
            scope.userVariables = vars.userVariables;
            scope.systemVariables = vars.systemVariables;
            bindWatchers();
          });
        };

        const combine = function () {
          variablesService.combineVariables(scope.userVariables, scope.systemVariables, function (variables) {
            scope.variables = variables;
            scope.changed = !_.isEqual(variables, scope._default);
            validate();
          });
        };

        let userVariablesWatch;
        let systemVariablesWatch;

        var bindWatchers = function () {
          userVariablesWatch = scope.$watch('userVariables', combine, true);
          systemVariablesWatch = scope.$watch('systemVariables', combine, true);
        };

        const unbindWatchers = function () {
          if (userVariablesWatch) userVariablesWatch();
          if (systemVariablesWatch) systemVariablesWatch();
        };

        let exitingKeys = {};
        const key = {
          regexp: {
            format: /^[a-zA-Z_]+[\w]*$/,
          },
          isFormatValid(alias) {
            return this.regexp.format.test(alias);
          },
          isValid(alias) {
            let isFormatValid = this.isFormatValid(alias);
            if (exitingKeys[alias]) {
              isFormatValid = false;
            } else {
              exitingKeys[alias] = true;
            }
            return isFormatValid && alias.length !== 0;
          },
        };

        const value = {
          isValid(value) {
            return undefined !== value && value !== null && value !== '';
          },
        };

        const validateVariables = function (variable) {
          variable.valueInvalid = !value.isValid(variable.value);
          variable.keyInvalid = !key.isValid(variable.key);
          if (variable.valueInvalid || variable.keyInvalid) {
            scope.valid = false;
            scope.error = !scope.valid;
          }
        };

        var validate = function () {
          exitingKeys = {};
          scope.valid = true;
          scope.error = !scope.valid;
          if (scope.isUserVariables && scope.editable) _.each(scope.userVariables, validateVariables);
          if (!scope.isUserVariables && scope.editable) _.each(scope.systemVariables, validateVariables);
        };

        separateVariables(scope.usePackageDefault);

        scope.$on(EVENTS.JOB_VARIABLES_LOADED, function (event, variables) {
          scope.variables = variables;
          unbindWatchers();
          separateVariables(scope.usePackageDefault);
        });

        scope.save = function () {
          if (dynamicConnectionService.dynamicConnectionVariables) {
            console.log(
              'dynamicConnectionService.dynamicConnectionVariables',
              dynamicConnectionService.dynamicConnectionVariables,
            );
            scope.variables = {
              ...scope.variables,
              ...dynamicConnectionService.dynamicConnectionVariables,
            };
          }

          dynamicConnectionService.dynamicConnectionVariables = null;

          ngrxStoreService.dispatch(updateVariables({ variables: scope.variables }));
          ngrxStoreService.dispatch(setDidUserSaveVariablesFlag({ value: true }));
          $rootScope.$broadcast(EVENTS.PACKAGE_VARIABLES_SAVE, scope.variables, scope.isInModalPanel);
        };

        scope.cancel = function () {
          const $modalPanel = angular.element('.modal-panel');
          if ($modalPanel.length) {
            $rootScope.$broadcast(EVENTS.MODAL_PANEL_CLOSE);
          } else {
            $rootScope.$broadcast(EVENTS.MODAL_CLOSE);
          }
        };

        const setVariablesToSet = function (variables) {
          _.each(variables, function (variable) {
            if (scope.variablesToSet && scope.variablesToSet[variable.key]) {
              variable.value = scope.variablesToSet[variable.key];
            }
          });
        };

        setVariablesToSet(scope.userVariables);
        setVariablesToSet(scope.systemVariables);

        scope.$watch(
          'variablesToSet',
          function (variablesToSet) {
            if (variablesToSet) separateVariables(true);
          },
          true,
        );

        $rootScope.getCurrentEditorVariables = function () {
          return angular.copy(scope.variables);
        };

        scope.compile = true;
      },

      controller: [
        '$scope',
        function ($scope) {
          $scope._default = angular.copy($scope.variables);
          $scope.changed = false;
          $scope.editable = true;
          $scope.isUserVariables = true;
          $scope.hideAdd = false;
          $scope.hideFooter = false;
          $scope.hideRemove = false;
          $scope.showUndo = false;
          $scope.compile = false;
          $scope.disableKey = false;

          $scope.userVariables = [];
          $scope.systemVariables = [];
          $scope.usePackageDefault = false;
        },
      ],
    };
  },
]);
